module.exports = __webpack_public_path__ + "static/holy_avenger-c6777c0b1e11e0162f133c814a19285c.jpeg";